
const digest = '44513640cf82d32cd8eb1ec40f84e3f43e456e32b3084aebc88a44fae0d8f4e0';
const classes = {"clickable":"_clickable_1ucdc_1"};
const css = `._clickable_1ucdc_1 {
  cursor: pointer;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  